import { FirebaseService } from "@/services/firebaseService"

const useFirebase = () => { 
    const createUser = async (email: string, password: string, displayName: string) => {
        const response = await FirebaseService.createUser(email,password,displayName);
        return response;
    }
    
    const getPhotoImage = async (businessId: number) : Promise<string> => {
        const PhotoURL = await FirebaseService.getPhotoImage(businessId);
        if(PhotoURL) {
            return PhotoURL;
        }
        return '';
    }
    
    return { createUser, getPhotoImage }
}
export default useFirebase